module.exports = __webpack_public_path__ + "img/i_media_tracker-4.4321a306.png";